import React from "react";
import { Target, ShieldCheck, Building2 } from "lucide-react";

const PILLARS = [
  {
    Icon: Target,
    title: "Business First",
    body: "AI focused on outcomes, not experimentation.",
  },
  {
    Icon: Building2,
    title: "Swiss Reliability",
    body: "Professional implementation and long-term support.",
  },
  {
    Icon: ShieldCheck,
    title: "Compliance Expertise",
    body: "Experience supporting regulated industries and operational processes.",
  },
];

export const WhoWeAre = () => {
  return (
    <section
      id="who-we-are"
      data-testid="who-we-are-section"
      className="relative py-20 lg:py-28 bg-soft"
    >
      <div className="mx-auto max-w-6xl px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <span className="chip">
              <span className="chip-dot" />
              <span className="font-mono text-[12px] text-ink-200">
                Who We Are
              </span>
            </span>
            <h2
              className="mt-7 headline"
              style={{ fontSize: "clamp(1.85rem, 4vw, 3.2rem)" }}
            >
              Practical AI for <em>Real Businesses.</em>
            </h2>
          </div>

          <div className="lg:col-span-7 lg:pt-3">
            <p className="text-[16.5px] lg:text-[17.5px] leading-[1.75] text-ink-200/80 font-light">
              We help businesses implement AI, automation and intelligent
              workflows that reduce manual work, improve customer experience
              and create measurable business results.
            </p>
          </div>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          {PILLARS.map((p, i) => (
            <div
              key={p.title}
              data-testid={`pillar-${i}`}
              className="card-surface p-7 lg:p-8"
            >
              <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-[#EFF4FF] to-[#DCE6FE] border border-brand-glow/30 flex items-center justify-center">
                <p.Icon size={18} className="text-brand" strokeWidth={1.6} />
              </div>
              <h3
                className="mt-7 text-[20px] tracking-tight text-ink-50"
                style={{ fontWeight: 500, letterSpacing: "-0.02em" }}
              >
                {p.title}
              </h3>
              <p className="mt-3 text-[15px] leading-[1.65] text-ink-200/80 font-light">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
